import { Theme, Grid, Paper, Box } from "@mui/material";
import FormLayout from "../../../components/FormLayout";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";

import { RootState } from "../../../store";
import { ErrorAlert } from "../../../components/Alerts";
import { useState } from "react";
import PayLaterPrompt from "./PayLaterPrompt";
import { useCollectionYear } from "../../../hooks/User";
import { paymentSlice } from "../../../store/reducer/payment";
import { HTTPRequestStatus } from "../../../utils/models";
import { usePaymentContainerContext } from "../PaymentContainer";
import { TaxCalculations } from "../../../model/tax_calculations";

const PayLater = ({collectionYear, taxReturnID, taxCalculations}: {collectionYear: string, taxReturnID: number|null, taxCalculations: TaxCalculations}) => {
  const dispatch = useDispatch();
  const [showPrompt, setShowPrompt] = useState(false);
  const user = useSelector(
    (appState: RootState) => appState.user.data
  );
  const { alertMessage, payLaterRequestStatus } = useSelector(
    (appState: RootState) => appState.payment
  );
  const endOfFiling = useSelector(
    (appState: RootState) => appState.state.season?.endOfFiling
  );
  const filingString = import.meta.env.VITE_APP_SAAS_CUSTOMER_FILING_DUE;

  return (
    <>
      {payLaterRequestStatus === HTTPRequestStatus.Error && <ErrorAlert>{alertMessage}</ErrorAlert>}
      {!!taxCalculations.final_balance && <Paper elevation={0} className='paper-container pay-later'>
        <h2 className='payment-card-title'>Pay Later</h2>
        <p>
          If you choose to pay later, your tax filing will be complete, but you will still have to pay your
          balance due on/before {filingString}. Select "Pay Later" (below) to receive an E-mail with information
          on your future payment options. Note: Once you make this selection, you will not be able to log back into LIME
          to make a payment at a later date.
        </p>
        <PayLaterPrompt
          show={showPrompt}
          onConfirm={taxReturnID ? () => dispatch(paymentSlice.actions.payLaterRequest({
              tax_return_id: taxReturnID!,
              amount: taxCalculations.final_balance,
              includes_quarterly_estimated_payment: false
            })) : () => { }}
          onCancel={() => setShowPrompt(false)}
        />
        <div className='btn-container start'>
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"Pay Later"}
            type="submit"
            disabled={!taxReturnID}
            onClick={() => setShowPrompt(true)}
          />
        </div>
      </Paper>}
    </>
  );
};

export default PayLater;
